export { BtnIconMore2 } from "./BtnIconMore2";
